export const initialState = {
  businessTaxes: [],
  businessTaxesLoading: false,
  businessTaxNextTokens: { 1: null },
  businessTaxesError: null,
  newTax: "",
  newTaxLoading: false,
  newTaxError: null,
  taxID: "",
  updateTaxLoading: false,
  updateTaxError: null,
  deleteTaxLoading: false,
  deleteTaxError: null,
  businessTax: {},
  businessTaxLoading: false,
  businessTaxError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_BUSINESS_TAX":
      return {
        ...state,
        request: action.payload.request,
        businessTaxes: [],
        businessTaxesLoading: true,
        businessTaxesError: null,
        businessTaxNextTokens:
          action.payload.page === 1
            ? initialState.businessTaxNextTokens
            : state.businessTaxNextTokens,
      };
    case "LIST_BUSINESS_TAX_SUCCESS":
      return {
        ...state,
        request: null,
        businessTaxes: action.payload.items,
        businessTaxesLoading: false,
        businessTaxNextTokens: {
          ...state.businessTaxNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_BUSINESS_TAX_ERROR":
      return {
        ...state,
        request: null,
        businessTaxesLoading: false,
        businessTaxesError: action.error,
      };
    case "REQUEST_GET_BUSINESS_TAX":
      return {
        ...state,
        request: action.payload.request,
        businessTax: {},
        businessTaxLoading: true,
        businessTaxError: null,
      };
    case "GET_BUSINESS_TAX_SUCCESS":
      return {
        ...state,
        businessTax: action.payload.tax,
        businessTaxLoading: false,
        request: null,
      };
    case "GET_BUSINESS_TAX_ERROR":
      return {
        ...state,
        businessTaxLoading: false,
        businessTaxError: action.error,
        request: null,
      };
    case "REQUEST_CREATE_BUSINESS_TAX":
      return {
        ...state,
        request: action.payload.request,
        newTax: "",
        newTaxError: null,
        newTaxLoading: true,
      };
    case "SUCCESS_CREATE_BUSINESS_TAX":
      return {
        ...state,
        request: null,
        newTax: action.payload.tax,
        businessTaxes: [action.payload.tax, ...state.businessTaxes],
        newTaxLoading: false,
      };
    case "ERROR_CREATE_BUSINESS_TAX":
      return {
        ...state,
        request: null,
        newTaxLoading: false,
        newTaxError: action.error,
      };
    case "REQUEST_DELETE_BUSINESS_TAX":
      return {
        ...state,
        request: action.payload.request,
        deleteTaxLoading: true,
        deleteTaxError: null,
        deletedID: "",
      };
    case "DELETE_BUSINESS_TAX_SUCCESS":
      return {
        ...state,
        request: null,
        businessTaxes: state.businessTaxes.filter(
          (tax) => tax.id !== action.payload.id
        ),
        deleteTaxLoading: false,
        deletedID: action.payload.id,
      };
    case "DELETE_BUSINESS_TAX_ERROR":
      return {
        ...state,
        request: null,
        deleteTaxLoading: false,
        deleteTaxError: action.error,
      };
    case "REQUEST_UPDATE_BUSINESS_TAX":
      return {
        ...state,
        request: action.payload.request,
        taxID: "",
        updateTaxError: null,
        updateTaxLoading: true,
      };
    case "UPDATE_BUSINESS_TAX_SUCCESS":
      const { tax } = action.payload;
      const updatedTaxesUpdate = state.businessTaxes.map((businessTax) =>
        businessTax.id === tax.id ? tax : businessTax
      );
      return {
        ...state,
        request: null,
        taxID: tax.id,
        updateTaxLoading: false,
        businessTaxes: updatedTaxesUpdate,
      };
    case "ERROR_UPDATE_BUSINESS_TAX":
      return {
        ...state,
        request: null,
        updateTaxLoading: false,
        updateTaxError: action.error,
      };
    case "CLEAR_BUSINESS_TAX":
      return {
        ...state,
        newTax: "",
        taxID: "",
        businessTax: {},
        deletedID: "",
      };
    // Leaves businessTaxesError alone: closing a modal must not turn a failed
    // list load into an empty list. The next list request resets it.
    case "CLEAR_BUSINESS_TAX_ERROR":
      return {
        ...state,
        newTaxError: null,
        updateTaxError: null,
        deleteTaxError: null,
      };
    // A save abandoned mid-flight (its modal closed). Without a case here its
    // loading flag stayed on and the next open showed a spinning button.
    case "CANCEL_UPDATE_BUSINESS_TAX":
      return {
        ...state,
        request: null,
        newTaxLoading: false,
        updateTaxLoading: false,
      };
    default:
      return state;
  }
};
